// -----------------------------------------------------------------------------
// Libraries
// -----------------------------------------------------------------------------
import React, { useState } from "react";
import Modal from "antd/lib/modal";

// -----------------------------------------------------------------------------
// Store
// -----------------------------------------------------------------------------

// -----------------------------------------------------------------------------
// Components
// -----------------------------------------------------------------------------
import { EditWorkoutForm } from "components/Forms/Workout/EditWorkoutForm";
import { CloseIcon } from "components/Icons";
// -----------------------------------------------------------------------------
// Styles and utils
// -----------------------------------------------------------------------------
import StyledEditWorkoutModal from "./styles";
import { OfflineBanner } from "components/OfflineBanner";
// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------
const EditWorkoutModal = ({ open, setOpen, isEditingLive, setIsEditingLive, liveStream, onClose }) => {
	const [uploading, setUploading] = useState(false);
	const handleCloseModal = () => {
		if (uploading) {
			return;
		}
		setOpen(false);
		onClose?.();
		if (setIsEditingLive) {
			setIsEditingLive(false);
		}
	};

	return (
		<Modal
			maskClosable={false}
			key={liveStream ? liveStream.id : null}
			width={900}
			closeIcon={<CloseIcon data-id="close-edit-workout-modal" />}
			open={open}
			onCancel={handleCloseModal}
			footer={null}
			destroyOnClose
		>
			<StyledEditWorkoutModal data-id="edit-workout-modal" className="sb-edit-workout-modal">
				<OfflineBanner
					text="You are Currently Offline. Your changes may not be saved"
					style={{ padding: 9, borderRadius: 4 }}
				/>
				<EditWorkoutForm
					isEditingLive={isEditingLive}
					liveStream={liveStream}
					handleCloseModal={handleCloseModal}
					uploading={uploading}
					setUploading={setUploading}
				/>
			</StyledEditWorkoutModal>
		</Modal>
	);
};

export default EditWorkoutModal;

